// Copyright 2018-2023 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import Icon from "components/Icon/Icon";
import Column from "components/Column";
import Row from "components/Row";
import "./PageHeader.css";

export interface IPageHeaderProps {
  title: string;
  titleSize?: "lg" | "md";
  icon?: any;
  subtitle?: JSX.Element;
  filter?: JSX.Element;
  buttons?: JSX.Element[];
  version?: JSX.Element;
}
function PageHeader({
  title,
  titleSize = "lg",
  icon,
  subtitle,
  filter,
  buttons,
  version,
}: IPageHeaderProps) {
  return (
    <header className="kubeapps-header">
      <div className="kubeapps-header-content">
        <Row>
          <Column>
            <div className="kubeapps-title-section">
              <div className="img-container">{icon && <Icon icon={icon} />}</div>
              <div className="kubeapps-title-block">
                {titleSize === "lg" ? <h1>{title}</h1> : <h3>{title}</h3>}
                {subtitle && <div className="kubeapps-header-subtitle">{subtitle}</div>}
              </div>
              {filter}
            </div>
          </Column>
          <Column>
            <div className="control-buttons">
              {version && <div className="header-version">{version}</div>}
              {buttons ? (
                buttons.map((button, i) => (
                  <div className="header-button" key={`control-button-${i}`}>
                    {button}
                  </div>
                ))
              ) : (
                <></>
              )}
            </div>
          </Column>
        </Row>
      </div>
    </header>
  );
}

export default PageHeader;
